(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('SubscribeDeleteController',SubscribeDeleteController);

    SubscribeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Subscribe'];

    function SubscribeDeleteController($uibModalInstance, entity, Subscribe) {
        var vm = this;

        vm.subscribe = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Subscribe.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
